import { SavedSearchNS } from '../../../misc/saved-searches/models/saved-search.models';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { customFieldTagRegex } from '../constants/custom-field-tag.regex';
import { WorkflowModelsNS } from 'src/app/misc/workflow/models/add-update-workflow.models';

export function fieldTagsValidator(availableFields: SavedSearchNS.IField[]): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    if(!value)return null;

    let valid = checkValidTagsInText(availableFields,value);
    if(!valid.valid)return { 'invalidFieldTags': true, invalidTags: valid.invalidTags?.length>0 ? valid.invalidTags.join(', ') : null  }

    return null;
  }

}

export function checkValidTagsInText(availableFields: SavedSearchNS.IField[], value: string, compareField: string = 'name'){
    if(!value)return {valid: true, invalidTags: []};

    const addedTags: string[] = value.match(customFieldTagRegex)||[];
    const invalidTags: string[] = [];

    addedTags.map(labelName=>{
        const exist = availableFields.find(field=>field[compareField].trim()==labelName.trim());

        if(!exist){
            invalidTags.push(labelName);
        }
    });

    return {valid: invalidTags?.length==0, invalidTags};
}

export function fieldTagsRequiredValidator(workflowType: number): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {

      const value: string = control.value;

      if(!value || workflowType!=WorkflowModelsNS.WorkflowTypeEnum.TIME_DEPENDENT)return null;

      let addedTags: string[] = value.match(customFieldTagRegex)||[];
      addedTags = addedTags.filter(tag=> !['Sender','Receiver','DetailedHyperLink'].includes(tag));

      if(addedTags.length==0)return { 'fieldTagsRequired': true }

      return null;
    }

  }
